import { render, staticRenderFns } from "./CleanUp.vue?vue&type=template&id=04ae25ad&"
import script from "./CleanUp.vue?vue&type=script&lang=js&"
export * from "./CleanUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports